import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ArticlePreview() {
  const { t } = useTranslation();

  return (
    <section id="articles" className="py-16 md:py-20 bg-background-50">
      <div className="px-6 md:px-10 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5">
            <div className="rounded-2xl overflow-hidden aspect-[4/5] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20clean%20workspace%20with%20laptop%20showing%20spreadsheet%20data%20and%20product%20photos%2C%20minimal%20scandinavian%20desk%20setup%2C%20soft%20natural%20light%20from%20window%2C%20warm%20beige%20and%20cream%20tones%2C%20professional%20sourcing%20atmosphere%2C%20elegant%20editorial%20photography%2C%20no%20text%20no%20watermark&width=600&height=750&seq=article-preview-main&orientation=portrait"
                alt="YOYBUY Sheet руководство"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full lg:w-3/5 flex flex-col justify-center">
            <span className="text-xs tracking-widest uppercase text-primary-500 mb-3 font-label">
              {t('section_article_label')}
            </span>

            <h3 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight mb-8">
              {t('section_article_title')}
            </h3>

            <blockquote className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 border-l-3 border-primary-300 pl-5 italic">
              &ldquo;{t('section_article_quote')}&rdquo;
            </blockquote>

            <p className="text-foreground-500 text-sm mb-8">
              &mdash; {t('section_article_author')}
            </p>

            <Link
              to="/yoybuy-sheet-guide"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-all w-fit whitespace-nowrap cursor-pointer"
            >
              <span>{t('btn_read_article')}</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}